import { auth, telemetry } from "../api"
import router from "../router"
import Vue from 'vue'

export default {
  initStore(context) {
    //let device = router.history.current.fullPath
    context.dispatch("loadGroups").then(() => {
    })
    context.dispatch("loadZones").then(() => {
    })
    context.dispatch("loadTags").then(() => {
    })
  },
  loadGroups(context) {
    return telemetry.groups().then(function(response) {
      context.commit("setGroups", {
        groups: response.data
      })
    }).catch(function(erro) {
      context.commit("setGroups", {
        groups: []
      })
    })
  },
  loadZones(context) {
    return telemetry.zones().then(function(response) {
      context.commit("setZones", {
        zones: response.data
      })
    }).catch(function(erro) {
      context.commit("setZones", {
        zones: []
      })
    })
  },
  loadTags(context) {
    return telemetry.tags().then(function(response) {
      context.commit("setTags", {
        tags: response.data.tags
      })
    }).catch(function(erro) {
      context.commit("setTags", {
        tags: []
      })
    })
  },
  loadPoles(context) {
    return telemetry.poles().then(response => {
      if(response.data !== undefined && response.data.length > 0) {
        var poles = []
        response.data.forEach(function (item) {
          poles.push(item.device)
        })

        this._vm.$socket.emit("subscribe", {devices: poles, token: localStorage.token})

        context.commit("setPoles", {
          poles: response.data
        })
      }
    }).catch(function(erro) {
      context.commit("setPoles", {
        poles: []
      })
    })
  },
  loadBuildings(context) {
    return telemetry.buildings().then(response => {      
      if(response.data !== undefined && response.data.length > 0) {
        var devices = []
        response.data.forEach(function (building) {
          if(building.devices) building.devices.forEach(function (device) {
            devices.push(device.id)
          })
        })
        
        this._vm.$socket.emit("subscribe", {devices: devices, token: localStorage.token})

        context.commit("setBuildings", {
          buildings: response.data
        })
      }
    }).catch(function(erro) {
      console.error(erro)
      context.commit("setBuildings", {
        buildings: []
      })
    })
  },
  changeDevice(context, data){
    if (this._vm.$socket) {
      context.commit("setCurrentDevice", data)
    }
  },
  SOCKET_data(context, data) {
    if(data.event != 'heartbeat') Vue.toasted.success('Update received (' + data.device + ') - ' + String.prototype.toUpperCase.call(data.event))

    if(data.type == 'simplemeter' && context.state.buildings && context.state.buildings.length > 0) {
      context.commit("updateBuildings", data)
    }

    // Update Current Device
    if(context.state.currentDevice !== null && data.device == context.state.currentDevice.device) {
      if(data.type == 'pole') {
        var newObj = { ...context.state.currentDevice }
        if(data.tiltx !== undefined) newObj.tiltx = data.tiltx
        if(data.tilty !== undefined) newObj.tilty = data.tilty
        if(data.tiltz !== undefined) newObj.tiltz = data.tiltz
        if(data.event !== undefined) newObj.event = data.event
        if(data.time !== undefined) newObj.time = data.time
        if(data.voltage !== undefined) newObj.voltage = data.voltage
        if(data.temperature !== undefined) newObj.temperature = data.temperature
        if(data.humidity !== undefined) newObj.humidity = data.humidity
        context.commit("setCurrentDevice", newObj)
      }
    }
  },
  SOCKET_annot(context, annot) {
    console.log(annot)
  },
  SOCKET_connect(context) {
    if (this._vm.$socket) {
    }
  },
  SOCKET_disconnect(context) {
  }
}
